import React from 'react'
import "../style/Certificate.css"


const Certificate = () => {
  return (
    <div className='certificate'>
        <h1>
            We are ISO Certified!!
        </h1>
        <div className='certificate_img'>

        </div>

    </div>
  )
}

export default Certificate